<template>
    <b-sidebar
        id="review-form-sidebar"
        :visible="isReviewFormSidebarActive"
        bg-variant="white"
        sidebar-class="sidebar-lg"
        shadow
        backdrop
        no-header
        right
        @shown="getData(reviewData)"
        @hidden="resetForm"
        @change="(val) => $emit('update:is-review-form-sidebar-active', val)"
    >
        <template #default="{ hide }">
            <div
                class="d-flex justify-content-between align-items-center content-sidebar-header px-2 py-1"
            >
                <h5 class="mb-0">Review Form</h5>
                <feather-icon
                    class="ml-1 cursor-pointer"
                    icon="XIcon"
                    size="16"
                    @click="hide"
                />
            </div>
            <validation-observer #default="{ handleSubmit }" ref="refFormObserver">
                <b-form
                    class="p-2"
                    @submit.prevent="handleSubmit(onSubmit)"
                    @reset.prevent="resetForm"
                >
                    <b-tabs v-model="tabIndex">
                        <b-tab title="Content">
                            <b-tabs content-class="mt-1" v-if="langs.length > 0">
                                <b-tab
                                    v-for="(lang, key) in langs"
                                    :key="'tab-' + key"
                                    :title="lang.name"
                                >
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'title_' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Title"
                                            :label-for="'title_' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'title_' + lang.code"
                                                v-model="Data.title[lang.code]"
                                                autofocus
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'title (' + lang.code + ')'"
                                                @input="changeTitle(lang.code)"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'description_' + lang.code"
                                        rules="min:0"
                                    >
                                        <b-form-group
                                            label="Description"
                                            :label-for="'description_' + lang.code"
                                        >
                                            <quill-editor
                                                :options="editorOptions"
                                                :id="'description_' + lang.code"
                                                v-model="Data.description[lang.code]"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                    <validation-provider
                                        #default="validationContext"
                                        :name="'slug' + lang.code"
                                        rules="required"
                                    >
                                        <b-form-group
                                            label="Slug"
                                            :label-for="'slug' + lang.code"
                                        >
                                            <b-form-input
                                                :id="'slug' + lang.code"
                                                v-model="Data.slug[lang.code]"
                                                :state="getValidationState(validationContext)"
                                                trim
                                                :placeholder="'Slug (' + lang.code + ')'"
                                            />
                                            <b-form-invalid-feedback>
                                                {{ validationContext.errors[0] }}
                                            </b-form-invalid-feedback>
                                        </b-form-group>
                                    </validation-provider>
                                </b-tab>
                            </b-tabs>
                            <hr />
                            <validation-provider
                                #default="validationContext"
                                :name="'blogger_url'"
                            >
                                <b-form-group
                                    label="Blogger URL"
                                    :label-for="'blogger_url'"
                                >
                                    <b-form-input
                                        :id="'blogger_url'"
                                        v-model="Data.blogger_url"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        :placeholder="`blogger url`"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <div class="border rounded p-2">
                                <h4 class="mb-1">Cover Image</h4>
                                <b-media
                                    no-body
                                    vertical-align="center"
                                    class="flex-column flex-md-row"
                                >
                                    <b-media-aside>
                                        <b-img
                                          ref="refPreviewEl"
                                          :src="Data.cover_image !== ''? Data.cover_image: require('@/assets/images/no-image.png')"
                                          height="75"
                                          width="75"
                                          class="rounded mr-2 mb-1 mb-md-0"
                                        />
                                    </b-media-aside>
                                    <b-media-body>
                                        <small class="text-muted">
                                            Required image resolution 800x400, image size 10mb.
                                        </small>
                                        <b-card-text class="my-50"> </b-card-text>
                                        <div class="d-inline-block">
                                            <b-form-file
                                                ref="refInputEl"
                                                v-model="Data.iconFile"
                                                accept=".jpg, .png, .gif, .webp,"
                                                placeholder="Choose file"
                                                @input="inputImageRenderer"
                                            />
                                        </div>
                                        <b-card-text class="my-50">
                                            <b-button
                                                v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                                                variant="outline-primary"
                                                v-if="Data.cover_image"
                                                @click="revomeImage"
                                            >
                                                Remove Image
                                            </b-button>
                                        </b-card-text>
                                    </b-media-body>
                                </b-media>
                            </div>
                            <br/>
                            <validation-provider
                                #default="validationContext"
                                name="IsActive"
                                rules="required"
                            >
                                <b-form-group label="Is Active" label-for="IsActive">
                                    <b-form-checkbox
                                        id="isactive"
                                        checked="true"
                                        class="custom-control-success"
                                        v-model="Data.is_active"
                                        switch
                                    />
                                    <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <repeater-section-form
                                v-if="isReviewFormSidebarActive && reviewData"
                                @refesh-list="refeshList"
                                :review-data="reviewData"
                                :review-input-content-remove.sync="ReviewInputContentRemove"
                                :review-input-content.sync="ReviewInputContent"
                            />
                        </b-tab>
                        <b-tab title="Gallery" v-if="reviewData">
                            <upload-form v-if="tabIndex == 1" :review-data.sync="reviewData" />
                        </b-tab>
                        <b-tab title="SEO">
                            <validation-provider
                                #default="validationContext"
                                name="meta_title"
                                rules="min:0"
                            >
                                <b-form-group label="Meta Title" label-for="meta_title">
                                    <b-form-input
                                        id="meta_title"
                                        v-model="Data.meta_title"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Title"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_description"
                                rules="min:0"
                                
                            >
                                <b-form-group
                                label="Meta Description"
                                label-for="meta_description"
                                >
                                <b-form-input
                                    id="meta_description"
                                    v-model="Data.meta_description"
                                    autofocus
                                    :state="getValidationState(validationContext)"
                                    trim
                                    placeholder="Meta Description"
                                />

                                <b-form-invalid-feedback>
                                    {{ validationContext.errors[0] }}
                                </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                            <validation-provider
                                #default="validationContext"
                                name="meta_keywords"
                                rules="min:0"
                            >
                                <b-form-group
                                    label="Meta Keywords"
                                    label-for="meta_keywords"
                                >
                                    <b-form-input
                                        id="meta_keywords"
                                        v-model="Data.meta_keyword"
                                        autofocus
                                        :state="getValidationState(validationContext)"
                                        trim
                                        placeholder="Meta Keywords"
                                    />
                                    <b-form-invalid-feedback>
                                        {{ validationContext.errors[0] }}
                                    </b-form-invalid-feedback>
                                </b-form-group>
                            </validation-provider>
                        </b-tab>
                    </b-tabs>
                    <div class="d-flex mt-2">
                        <b-button
                          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                          variant="outline-success"
                          class="mr-2"
                          type="submit"
                        >
                          Save
                        </b-button>
                        <b-button
                          v-ripple.400="'rgba(186, 191, 199, 0.15)'"
                          type="button"
                          variant="outline-danger"
                          @click="hide"
                        >
                          Cancel
                        </b-button>
                    </div>
                </b-form>
            </validation-observer>
        </template>
    </b-sidebar>
</template>

<script>
import { $themeConfig } from '@themeConfig'
import {
    BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
    BButton, BTabs, BTab, BCard, BCardText, BFormRadio, BFormRating, BContainer, BRow, BCol,
    BMedia, BMediaAside, BMediaBody, BImg, BFormFile
} from "bootstrap-vue";
import { required, alphaNum, email, password,confirmed } from '@validations'
import { ValidationProvider, ValidationObserver } from "vee-validate";
import vSelect from "vue-select";
import store from "@/store";
import formValidation from "@core/comp-functions/forms/form-validation";
import Ripple from "vue-ripple-directive";
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue";
import { useToast } from "vue-toastification/composition";
import { slugify } from "@/@fake-db/utils";
import { ref, onUnmounted } from "@vue/composition-api";
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import { quillEditor } from "vue-quill-editor";
import Quill from 'quill'
const sizeStyle = Quill.import('attributors/style/size')
sizeStyle.whitelist = ['6px', '8px', '10px', '12px', '14px', '16px', '18px', '20px', '24px', '30px', '32px', '36px']
Quill.register(sizeStyle, true)
import "quill/dist/quill.snow.css";
import "quill/dist/quill.core.css";
import "quill/dist/quill.bubble.css";
import { useInputImageRenderer } from "@core/comp-functions/forms/form-utils";

import languagesStoreModule from "@/views/languages/languagesStoreModule";
import UploadForm from "../review-form/UploadForm.vue"
import RepeaterSectionForm from "../review-form/RepeaterSectionForm.vue"
import reviewSectionStoreModule from "../reviewSectionStoreModule"
import reviewBlockStoreModule from "../reviewBlockStoreModule"

export default {
    components: {
        BSidebar, BForm, BFormGroup, BFormInput, BFormTextarea, BFormCheckbox, BFormInvalidFeedback,
        BButton, BTabs, BTab, BCard, BCardText, vSelect, ValidationProvider, BRow, BCol,
        ValidationObserver, quillEditor, BFormRadio, BFormRating, Treeselect, BContainer, BMedia, 
        BMediaAside, BMediaBody, BImg, BFormFile, UploadForm, RepeaterSectionForm,
    },

    directives: {
        Ripple,
    },

    model: {
        prop: "isReviewFormSidebarActive",
        event: "update:is-review-form-sidebar-active",
    },

    props: {
        isReviewFormSidebarActive: {
            type: Boolean,
            required: true,
        },
        reviewData: {
            type: Object,
            required: false,
        },
    },

    computed: {
        currentLocale() {
            return this.$i18n.locale;
        },
        editorOptions (){
            return $themeConfig.snowOption
        }
    },

    setup(props, { emit }){
        const {  appRef } = $themeConfig.app
        const toast = useToast();

        const LANGUAGES_STORE_MODULE_NAME = "app-languages";
        if (!store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.registerModule(LANGUAGES_STORE_MODULE_NAME, languagesStoreModule);
        onUnmounted(() => {
            if (store.hasModule(LANGUAGES_STORE_MODULE_NAME)) store.unregisterModule(LANGUAGES_STORE_MODULE_NAME);
        });

        const CONTENT_STORE_MODULE_NAME = 'review-section';
        if (!store.hasModule(CONTENT_STORE_MODULE_NAME)) store.registerModule(CONTENT_STORE_MODULE_NAME, reviewSectionStoreModule)
        onUnmounted(() => {
            if (store.hasModule(CONTENT_STORE_MODULE_NAME)) store.unregisterModule(CONTENT_STORE_MODULE_NAME)
        });

        const BLOCK_STORE_MODULE_NAME = 'section-block';
        if (!store.hasModule(BLOCK_STORE_MODULE_NAME)) store.registerModule(BLOCK_STORE_MODULE_NAME, reviewBlockStoreModule)
        onUnmounted(() => {
            if (store.hasModule(BLOCK_STORE_MODULE_NAME)) store.unregisterModule(BLOCK_STORE_MODULE_NAME)
        });

        const userStorage = JSON.parse(localStorage.getItem('userData'));
        const getLocalSite = JSON.parse(localStorage.getItem('site'))

        const blankData = {
            slug: {},
            is_active: true,
            ordering_count: 0,
            title: {},
            description: {},
            blogger_url: '',
            cover_image: '',
            meta_title: '',
            meta_description: '',
            meta_keyword: '',
            created_by: userStorage.id,
            sites_id: getLocalSite.id
        };

        const Data = ref(blankData);
        const tabIndex = ref(0);
        const langs = ref([]);
        const refInputEl = ref(null);
        const refPreviewEl = ref(null);
        const ReviewInputContentRemove = ref([])
        const ReviewInputContent = ref([])

        const resetData = () => {
            Data.value = blankData;
        };

        const getData = async (data) => {
            tabIndex.value = 0;
            refPreviewEl.value.src = require("@/assets/images/no-image.png");

            Data.value.slug = {}
            Data.value.is_active = true
            Data.value.title = {}
            Data.value.description = {}
            Data.value.cover_image = ''
            Data.value.blogger_url = ''
            Data.value.meta_title = ''
            Data.value.meta_description = ''
            Data.value.meta_keyword = ''

            if(data){
                data.is_active = data.is_active? true: false
                Data.value = data

                if(data.content.length){
                    ReviewInputContent.value = data.content
                } else {
                    ReviewInputContent.value = []
                }
            }
        }

        const changeTitle  = (lang) => {
            if(lang){
                Data.value.slug[lang] = slugify(Data.value.title[lang]);
            }
        }

        const getLangs = (filter) => {
            store.dispatch("app-languages/fetchData", filter).then((res) => {
                if (res.data.success) {
                    langs.value = res.data.data;
                }
            });
        };

        let filter = {
            is_active:1,
            
        }

        const { inputImageRenderer } = useInputImageRenderer(
            refInputEl,
            (base64) => {
                refPreviewEl.value.src = base64;
            }
        );

        const revomeImage = () => {
            Data.value.cover_image = require("@/assets/images/no-image.png");
        };

        const onSubmit = function () {
            Data.value.is_active = Data.value.is_active?1:0;

            let formData = new FormData();

            if (ReviewInputContentRemove.value.length > 0) {
                Data.value.content_remove = JSON.stringify(
                    ReviewInputContentRemove.value
                );
            }

            if (ReviewInputContent.value.length > 0) {
                Data.value.content = ReviewInputContent.value
                for (const [key, value] of Object.entries(ReviewInputContent.value)) {
                    ReviewInputContent.value[key].title_lang = JSON.stringify(value.title);
                }
                Data.value.content = JSON.stringify(ReviewInputContent.value);
            }

            for (const [key, value] of Object.entries(Data.value)) {
                if (key == "title" || key == "description" || key == "slug"){
                    formData.append(key, JSON.stringify(value));
                } else {
                    formData.append(key, value);
                }
            }

            formData.append(
                "count_conent_remove",
                ReviewInputContentRemove.value.length
            );
            formData.append('path', `/var/www/html/uploadfiles/uploads/${appRef}/review/`);
            formData.append('savepath', `uploads/${appRef}/review/`);
            formData.append("count_conent", ReviewInputContent.value.length);
            formData.append('iconFile', refInputEl.value.files[0])
            formData.append('data', JSON.stringify(Data.value))

            if(!Data.value.id){
                store.dispatch('app-review/addReview', formData)
                    .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        emit('refetch-data')
                        emit('update:is-review-form-sidebar-active', false)
                    })
                    .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: "Error",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: `${error?.response?.data?.message??'Something went wrong'}`,
                            },
                        })
                    })
            } else {
                store.dispatch('app-review/updateReview', {
                    id: Data.value.id,
                    formData: formData
                })
                .then((res) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: `Success`,
                                icon: 'BellIcon',
                                variant: 'success',
                                text: `${res.data.message}`,
                            },
                        });

                        Data.value.cover_image = null
                        Data.value.files = []
                        emit('refetch-data')
                        emit('update:is-review-form-sidebar-active', false)
                })
                .catch((error) => {
                        toast({
                            component: ToastificationContent,
                            position: 'top-right',
                            props: {
                                title: "Error",
                                icon: 'AlertTriangleIcon',
                                variant: 'danger',
                                text: `${error?.response?.data?.message??'Something went wrong'}`,
                            },
                        })
                    })
            }
        }

        const {
            resetForm,
            getValidationState,
            refFormObserver
        } = formValidation(resetData);

        getLangs(filter);

        const refeshList = async () => {
            emit("refetch-data");
        };

        return {
            resetForm,
            getValidationState,
            refFormObserver,
            resetData,
            getData,
            tabIndex,
            langs,
            refeshList,
            getLangs,
            Data,
            inputImageRenderer,
            revomeImage,
            changeTitle,
            onSubmit,
            ReviewInputContentRemove, 
            ReviewInputContent,
            refPreviewEl,
            refInputEl,
            revomeImage,
        }
    },

    methods: {

    }
}
</script>

<style lang="scss">
    @import "@core/scss/vue/libs/quill.scss";
</style>